import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Icon, styled } from 'bonfire-kindling';

const StyledButton = styled('button', {
  shouldForwardProp: prop =>
    prop !== 'isFocused' && prop !== 'isComplete' && prop !== 'isNotAllowed',
})(({ theme, isFocused, isComplete, isNotAllowed }) => ({
  background: isFocused
    ? theme.palette.purple.light
    : isComplete
    ? theme.palette.purple.main
    : theme.palette.common.white,
  color: isComplete ? theme.palette.common.white : theme.palette.purple.main,
  width: '30px',
  height: '30px',
  borderRadius: '17px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: theme.palette.purple.main,
  border: isComplete ? 'none' : undefined,
  padding: 0,
  font: 'inherit',
  cursor: isNotAllowed ? 'not-allowed' : 'pointer',
  outline: 'inherit',
  '&:hover': {
    background: theme.palette.purple.light,
  },
}));

const Step = ({ isActive, isComplete, isNotAllowed, onClick, cypress, index }) => {
  const [isFocused, setFocus] = useState(false);
  const { t } = useTranslation();

  return (
    <Box sx={{ position: 'relative' }}>
      {isActive && (
        <Box
          sx={{
            position: 'absolute',
            width: '6px',
            height: '6px',
            borderRadius: '3px',
            left: '22px',
            background: theme => theme.palette.purple.main,
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '50px',
          height: '50px',
        }}
      >
        <StyledButton
          type="button"
          isFocused={isFocused}
          isComplete={isComplete}
          isNotAllowed={isNotAllowed}
          onClick={onClick}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          data-cy={cypress}
          aria-label={t('components.step', { step: index + 1 })}
        >
          <Box as="span">
            {isComplete ? (
              <Icon iconName="check" />
            ) : (
              <Box as="span" aria-hidden>
                {index + 1}
              </Box>
            )}
          </Box>
        </StyledButton>
      </Box>
    </Box>
  );
};

export default Step;
